import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { toast } from "react-hot-toast";
import PsContext from "../../../../context";
import axios from "axios";
import { ServiceUrl } from "../../../../utils/serviceUrl";
import { baseUrl } from "../../../../utils";

const ProfilePhotoUpload = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [version, setVersion] = useState(0);
  const [selectedFileName, setSelectedFileName] = useState("");

  useEffect(() => {
    // Reset preview when applicant or file path changes
    setImagePreview(null);
    setSelectedFile(null);
    setVersion((prev) => prev + 1); // bust cache
  }, [props.filePath]);

  const fileReaderChange = (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      const totalsize = file.size;
      const minKB = props.minSize / 1000;
      const maxKB = props.maxSize / 1000;

      if (totalsize < props.minSize) {
        toast.error("File size must be greater than " + minKB + " KB");
        setSelectedFileName(""); // clear filename
        return;
      }

      if (totalsize > props.maxSize) {
        toast.error("File size must be less than " + maxKB + " KB");
        setSelectedFileName(""); // clear filename
        return;
      }

      setSelectedFile(file);
      setSelectedFileName(file.name);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (readerEvent) => {
        setImagePreview(readerEvent.target.result);

        // ✅ Auto-upload after preview is ready
        setTimeout(() => {
          uploadFile(file);
        }, 100);
      };
    } catch (err) {
      console.error("File read error:", err);
    }
  };

  const getFileUrl = () => {
    if (imagePreview) return imagePreview;

    if (props.filePath) {
      return `${baseUrl}${ServiceUrl.PG.VIEW_CERTIFICATE}?api_code=${context.user.api_code}&field_name=${props.fileName}&v=${version}`;
    }

    return "";
  };

  const uploadFile = (fileToUpload) => {
    setLoader(true);
    context.setLoader(true);

    const form = new FormData();
    form.append("i__apiCode", context.user.api_code);
    form.append("i__userId", context.user.user_id);
    form.append("i__userCode", context.user.user_code);
    form.append("i__fileName", props.fileName);
    form.append("i___file", fileToUpload || selectedFile);

    axios
      .post(ServiceUrl.PG.UPLOAD_FILE, form)
      .then((res) => {
        if (res.data.status === "1") {
          toast.success(res.data.message || "Upload successful");
          setSelectedFile(null);
          setImagePreview(null);
          setVersion((prev) => prev + 1);
          if (props.onSuccess) props.onSuccess();
        } else {
          toast.error(res.data.message || "Upload failed");
        }
      })
      .catch((err) => {
        console.error("Upload error:", err);
        toast.error("Upload failed. Please try again.");
      })
      .finally(() => {
        setLoader(false);
        context.setLoader(false);
      });
  };

  return (
    <div>
      <Form
        action=""
        method="post"
        encType="multipart/form-data"
        id="frm_PhotoUpload"
      >
        <Row className="border-bottom py-3">
          <Col md={8}>
            <b>{props.title}</b>
            <div className="upload_info mt-2">{props.content}</div>
          </Col>
          <Col md={4}>
            <center>
              <img
                src={getFileUrl()}
                alt="Profile Preview"
                style={{ width: "80px", cursor: "pointer" }}
              />
              <br />
              <input
                type="file"
                name="file"
                id={props.fileName}
                className="inputfile mt-2"
                onChange={(e) => {
                  fileReaderChange(e);
                }}
                accept=".png,.jpg,.jpeg"
              />
              <label htmlFor={props.fileName}>Choose a file</label>
              {selectedFileName && (
                <div className="mt-1 small text-muted">{selectedFileName}</div>
              )}
            </center>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ProfilePhotoUpload;
